export const initialState = {
  author: "",
  category: [],
  searchText: "",
};
